import { render, staticRenderFns } from "./Can.vue?vue&type=template&id=b0dc5872&"
import script from "./Can.vue?vue&type=script&lang=ts&"
export * from "./Can.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports